import { lazy, Suspense } from 'react';
import { ClinicRoute } from './routes/clinic-route.js';
import { ClinicLinkRoute } from './routes/clinic-link-route.js';
import { WaitNote } from './components/wait-note.js';

/* Clinics (033): the coach's side, lazy as the rest of it. */
const CoachClinicRoute = lazy(() =>
  import('./routes/coach-clinic-route.js').then((module) => ({ default: module.CoachClinicRoute })),
);
const CoachClinicFormRoute = lazy(() =>
  import('./routes/coach-clinic-form-route.js').then((module) => ({
    default: module.CoachClinicFormRoute,
  })),
);

const opening = <WaitNote className="empty">Opening…</WaitNote>;

export const clinicRoutes = [
  { path: 'booking/clinics/:clinicId', element: <ClinicRoute /> },
  /* The direct link: the one page a signed-out visitor sees (profile-gate.tsx). */
  { path: 'clinics/:token', element: <ClinicLinkRoute /> },
  { path: 'coach/clinics/new', element: <Suspense fallback={opening}><CoachClinicFormRoute /></Suspense> },
  { path: 'coach/clinics/:clinicId', element: <Suspense fallback={opening}><CoachClinicRoute /></Suspense> },
  { path: 'coach/clinics/:clinicId/edit', element: <Suspense fallback={opening}><CoachClinicFormRoute /></Suspense> },
];
